import { createBrowserHistory } from 'history';

export const routingHistory = createBrowserHistory();
